// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2xNkk","questions":"styles_questions__2WibL","footer":"styles_footer__1tQnd"};